<template>
  <main-message-form v-if="next" createForm :mandateData="formData" />
  <v-container v-else fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col class="pt-0" cols="12" md="12">
              <el-radio-group
                class="mt-0 mb-4"
                style="width: fit-content"
                label="inJournalType"
                v-model="inJournalTypeNotMappedSelected"
                :items="inJournalTypeNotMapped"
                required
              />
              <v-divider></v-divider>
            </v-col>
            <v-col
              v-if="showSubmandateCheckbox"
              class="pb-0 pt-0"
              cols="12"
              md="12"
            >
              <el-checkbox
                class="mt-0 mb-1"
                style="width: fit-content"
                label="Įgaliojimas, duotas perįgaliojant"
                v-model="formData.submandate"
              />
            </v-col>

            <v-col v-if="showCode" class="pb-0" cols="12" md="3">
              <el-text-field
                required
                label="Identifikavimo kodas"
                v-model="formData.code"
                cMask="10"
              />
            </v-col>
            <!-- FIZ card  -->
            <template v-if="showFizFields">
              <v-col class="pb-0" cols="12" md="6" lg="4">
                <el-text-field
                  required
                  label="Vardas"
                  tooltip="Vieša paieška. Paieška. Vardas"
                  v-model="formData.name"
                  validateKey="FIZ_name"
                  key="FIZ_name"
                  :maxlength="100"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6" lg="4">
                <el-text-field
                  required
                  label="Pavardė"
                  tooltip="Vieša paieška. Paieška. Pavardė"
                  v-model="formData.lastname"
                  validateKey="FIZ_lastname"
                  key="FIZ_lastname"
                  :maxlength="100"
                />
              </v-col>
              <v-col class="pt-0 pb-0" cols="12">
                <el-radio-group
                  class="mt-0 mb-4"
                  style="width: fit-content"
                  v-model="formData.searchType"
                  :items="searchType"
                  label="searchType"
                  required
                >
                </el-radio-group>
              </v-col>
              <template v-if="showSearchTypeCode">
                <v-col class="pb-0" cols="12" md="6" lg="4">
                  <el-text-field
                    required
                    label="Asmens kodas"
                    tooltip="Vieša paieška. Paieška. Asmens kodas"
                    v-model="formData.code"
                    validateKey="FIZ_code"
                    key="FIZ_code"
                    :cMask="11"
                    :length="11"
                  />
                </v-col>
              </template>
              <template v-if="showSearchTypeIltuCode">
                <v-col class="pb-0" cols="12" md="6" lg="4">
                  <el-text-field
                    required
                    label="ILTU kodas"
                    tooltip="Vieša paieška. Paieška. ILTU kodas"
                    v-model="formData.iltu_code"
                    validateKey="FIZ_iltu_code"
                    key="FIZ_iltu_code"
                    :maxlength="20"
                  />
                </v-col>
              </template>
              <template v-if="showSearchTypedateAnd">
                <v-col class="pb-0" cols="12" md="6" lg="4">
                  <el-date-picker
                    required
                    label="Gimimo data"
                    pastDates
                    tooltip="Vieša paieška. Paieška. Gimimo data"
                    v-model="formData.birth_date"
                    validateKey="UZS_birth_date"
                    key="UZS_birth_date"
                  />
                </v-col>
              </template>
              <v-col class="pt-0 pb-0" cols="12">
                <v-divider></v-divider>
              </v-col>
            </template>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
            v-if="!isErrorsCorrectionForm"
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button v-if="inJournalTypeNotMappedSelected"
              :title="primaryButtonTitle"
              :loading="loading"
              @click.native="search()"
              color="primary"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
    <modal-custom
      :title="$t('Įgaliojimo tėvinis įgaliojimas yra sustabdytas')"
      :text="$t(`Įgaliojimo tėvinis įgaliojimas yra sustabdytas - objekto ID ${this.formData.code}. Ar norite tęsti?`)"
      trueText="Tęsti"
      falseText="Atšaukti"
      :loading="loading"
      mid
      v-model="showSuspensionModal"
      @confirmData="confirmSuspensionModal"
    />
  </v-container>
</template>

<script>
import InJournalTypes from '@/components/constants/inJournalTypes'
import Roles from '@/components/constants/roles'
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import Enums from '@/enums'
import MainMessageForm from './MainMessageForm.vue'
import ModalCustom from '@/components/modals/ModalCustom'
import { getMandateByCode } from '@/services/noticeService.js'


export default {
  name: 'NewMessageForm',
  components: { MainMessageForm, ModalCustom },
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      savedDataBeforeNext: {},
      showSuspensionModal: false,
      InJournalTypes: InJournalTypes,
      Roles: Roles,
      pageloading: false,
      inJournalTypeNotMappedSelected: null,
      loading: false,
      formData: {},
      next: false
    }
  },
  computed: {
    primaryButtonTitle() {
      return (this.inJournalTypeNotMappedSelected == InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA && !this.formData.submandate) ? 'Tęsti' : 'Ieškoti'
    },
    showFizFields() {
      return this.inJournalTypeNotMappedSelected == 'MAP-411'
    },
    showSubmandateCheckbox() {
      return this.inJournalTypeNotMappedSelected == InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA
    },
    showCode() {
      return this.formData.submandate == true
              || this.inJournalTypeNotMappedSelected == InJournalTypes.PRANESIMAS_APIE_PAKEITIMA
              || this.inJournalTypeNotMappedSelected == InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA
              || this.inJournalTypeNotMappedSelected == 'MAP-424'
              || this.inJournalTypeNotMappedSelected == 'MAP-426'
              || this.inJournalTypeNotMappedSelected == 'MAP-428'
              || this.inJournalTypeNotMappedSelected == InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS
              || this.inJournalTypeNotMappedSelected == InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA
    },
    showSearchTypeCode() {
      return this.formData.searchType === 'ak'
    },
    showSearchTypeIltuCode() {
      return this.formData.searchType === 'iltu'
    },
    showSearchTypedateAnd() {
      return this.formData.searchType === 'birth-date-and-country'
    },
    searchType() {
      return [
        {
          label: this.$t('Asmens kodas'),
          value: 'ak',
        },
        {
          label: this.$t('ILTU kodas'),
          value: 'iltu',
        },
        {
          label: this.$t('Gimimo data'),
          value: 'birth-date-and-country',
        },
      ]
    },
    isErrorsCorrectionForm(){
      return this.$route.name == "errorsCorrectionNew"
    },
    inJournalTypeNotMapped() {
      let items = []
      // errors-correction
      if(this.isErrorsCorrectionForm){
        return [
          {
            label: this.$t(
              'Tarnybinis pranešimas apie registro duomenų netikslumus'
            ),
            value: InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS,
          },
          {
            label: this.$t(
              'Tarnybinis pranešimas apie klaidingai įregistruotą objektą'
            ),
            value: InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA,
          }
        ]
      }
      // else
      if (this.hasRole([Roles.NOTARAS, Roles.KONSULAS, Roles.NOT_PAD, Roles.KAL_VAD, Roles.NOT_PAD2])) {
        // NOTARO NTPI PRANESIMAI DAROMA VĖLIAU
        let addNt = [
          {
            label: this.$t(
              'Pranešimas Įgaliojimų registrui apie įgaliojimo patvirtinimą'
            ),
            value: InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA,
          },
          {
            label: this.$t(
              'Pranešimas Įgaliojimų registrui apie įgaliojimo pakeitimą'
            ),
            value: InJournalTypes.PRANESIMAS_APIE_PAKEITIMA,
          },
          {
            label: this.$t(
              'Pranešimas Įgaliojimų registrui apie įgaliojimo pasibaigimą'
            ),
            value: InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA,
          },
        ]
        items = [...items, ...addNt]
      }
      if (this.hasRole([Roles.TEISMAS, Roles.IR_REGISTRATORIUS])) {
        let add = [
          {
            label: this.$t(
              'Pranešimas Įgaliojimų registrui apie įgaliojimo / prokūros pasibaigimą'
            ),
            value: 'MAP-424',
          },
          {
            label: this.$t(
              'Pranešimas Įgaliojimų registrui apie įgaliojimo / prokūros galiojimo sustabdymą'
            ),
            value: 'MAP-426',
          },
          {
            label: this.$t(
              'Pranešimas Įgaliojimų registrui apie įgaliojimo galiojimo / prokūros sustabdymo panaikinimą'
            ),
            value: 'MAP-428',
          },
          {
            label: this.$t(
              'Pranešimas Įgaliojimų registrui apie įgaliotojo arba įgaliotinio / prokuristo pripažinimą nežinia kur esančiu'
            ),
            value: 'MAP-411',
          },
        ]
        items = [...items, ...add]
      }
      return items
    },
    modeReadonly() {
      return false
    },
    getTitle() {
      return this.$t(`Naujas pranešimas`)
    },
  },
  created() {},
  methods: {
    hasRole(roles) {
      const userRole = this.$store.getters.userRole
      return roles.some((item) => {
        return userRole.includes(item)
      })
    },
    back() {
      this.$router.push({ name: 'adminMessagesPreparedSent' })
    },
    setInJournalType(kind) {
      switch (this.inJournalTypeNotMappedSelected) {
        case InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA:
          this.$set(this.formData, 'is_submandate', this.formData.submandate || null) // BREAK is not needed. Further code must be executedfor all 3 types. This line is additional to this specific type
        case InJournalTypes.PRANESIMAS_APIE_PAKEITIMA:
        case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA:
        case InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS:
        case InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA:
          this.$set(this.formData, 'in_journal_type', this.inJournalTypeNotMappedSelected)
          break
        case 'MAP-424':
          this.$set(this.formData, 'in_journal_type', kind == 'NTPI' || kind == 'ITPSI' ? InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA : (kind == 'PP' || kind == 'ITPSP' ? InJournalTypes.PRANESIMAS_APIE_PROKUROS_PASIBAIGIMA : null))
          break
        case 'MAP-426':
          this.$set(this.formData, 'in_journal_type', kind == 'NTPI' || kind == 'ITPSI' ? InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMA : (kind == 'PP' || kind == 'ITPSP' ? InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMA : null))
          break
        case 'MAP-428':
          this.$set(this.formData, 'in_journal_type', kind == 'NTPI' || kind == 'ITPSI' ? InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMO_PANAIKINIMA : (kind == 'PP' || kind == 'ITPSP' ? InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMO_PANAIKINIMA : null))
          break
        case 'MAP-411':
          this.$set(this.formData, 'in_journal_type', InJournalTypes.PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_BENDRAS)
          break
      }
    },
    confirmSuspensionModal(){
      this.setInJournalType(this.savedDataBeforeNext.mandate_kind)
      this.$set(this.formData, 'mandate', this.savedDataBeforeNext)
      this.next = true;
    },
    clearPersonDocuments(person) {
      this.$set(person, 'person_documents', [])
      this.$set(person, 'person_document_files', null)
      this.$set(person, 'person_document_kind_id', null)
      this.$set(person, 'person_document_kind_title_lt', null)
      this.$set(person, 'person_document_date', null)
      this.$set(person, 'person_document_number', null)
      this.$set(person, 'showPersonDocument', false)
    },
    clearMandatePersonDocuments(mandate) {
      const personGroups = ['principals', 'representitives', 'sub_representitives']
      personGroups.forEach((group) => {
        if (!Array.isArray(mandate[group])) return
        mandate[group].forEach((person) => this.clearPersonDocuments(person))
      })
    },
    search() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          this.pageloading = true
          let formData = this.formData

          if (this.inJournalTypeNotMappedSelected == 'MAP-411') {
            this.$axios.post(`mandates/byPerson`, formData)
              .then((res) => {
                this.setInJournalType()
                this.$set(formData, 'mandates', res.data.mandates)
                this.$set(formData, 'person', {})
                this.$set(formData, 'person_amn_id', res.data.person_amn_id)
                this.$set(formData.person, 'name', formData.name)
                this.$set(formData.person, 'lastname', formData.lastname)
                this.$set(formData.person, 'code', formData.code)
                this.$set(formData.person, 'birth_date', formData.birth_date)
                this.$set(formData.person, 'iltu_code', formData.iltu_code)
                this.$set(formData.person, 'searchType', formData.searchType)
                this.next = true;
              })
              .catch((err) => {
                this.$root.$emit('DATA_ERROR', err)
              })
              .finally(() => {
                this.loading = false
                this.pageloading = false
              })
          } else if (this.inJournalTypeNotMappedSelected == InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA && !this.formData.submandate) {
              this.setInJournalType()
              this.next = true
          } else {
            let search = '';
            if ([InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA, InJournalTypes.PRANESIMAS_APIE_PAKEITIMA, InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS, InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA].includes(this.inJournalTypeNotMappedSelected)){
              search = 'NTPI'
            } else if ([InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA].includes(this.inJournalTypeNotMappedSelected) && this.hasRole(Roles.NOTARINIU_GRUPE)) {
              search = 'NTPI'
            }
            getMandateByCode(formData.code, search, this.inJournalTypeNotMappedSelected)
              .then((res) => {
                if(res.data.mandate.submandate_allowed == false && this.inJournalTypeNotMappedSelected == '401'){
                  return this.$root.$emit('DATA_ERROR_TEXT', 'Šio įgaliojimo negalima perįgalioti')
                }
                if(res.data.mandate.suspension_date && this.inJournalTypeNotMappedSelected == 'MAP-426'){
                   return this.$root.$emit('DATA_ERROR_CODE', '000095')
                }
                if(!res.data.mandate.suspension_date && this.inJournalTypeNotMappedSelected == 'MAP-428'){
                   return this.$root.$emit('DATA_ERROR_CODE', '000096')
                }
                if(this.inJournalTypeNotMappedSelected == '401' && res.data.mandate.suspension_date){
                  this.savedDataBeforeNext = res.data.mandate
                  return this.showSuspensionModal = true
                }

                this.setInJournalType(res.data.mandate.mandate_kind)
                const mandate = res.data.mandate
                this.clearMandatePersonDocuments(mandate)

                this.$set(formData, 'mandate', res.data.mandate)
                this.next = true;
              })
              .catch((err) => {
                this.$root.$emit('DATA_ERROR', err)
              })
              .finally(() => {
                this.loading = false
                this.pageloading = false
              })
          }
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
